module.exports = __webpack_public_path__ + "static/black-aa-hero-desktop.ab686432.webp";